import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    title: 'LISTA DE COMPRAS INTELIGENTE',
    value: '$26.000',
    description: 'Plantilla exacta para pedir materiales al distribuidor sin olvidarte de ningún accesorio, tornillo o burlete.'
  }, {
    title: 'SCRIPTS WHATSAPP + INSTAGRAM',
    value: '$26.000',
    description: 'Mensajes pre-armados para responder consultas de precio, hacer seguimiento y cerrar ventas sin parecer desesperado.'
  }, {
    title: 'CHECKLIST DE MEDICIÓN EN OBRA',
    value: '$26.000',
    description: 'El paso a paso para tomar medidas en obra y no llevarte sorpresas cuando vas a instalar. Falsas escuadras y plomos.'
  }, {
    title: 'CROQUIS Y PLANOS BASE',
    value: '$26.000',
    description: 'Modelos de croquis profesionales para adjuntar a tus presupuestos y darle una imagen premium a tu taller.'
  }, {
    title: 'CONTROL DE CALIDAD FINAL',
    value: '$26.000',
    description: 'Los 15 puntos que tenés que revisar en el taller antes de cargar la abertura en la camioneta.'
  }, {
    title: 'TRACKER DE COSTOS Y RENTABILIDAD',
    value: '$26.000',
    description: 'Herramienta simple para anotar tus gastos fijos y saber exactamente cuánto ganaste a fin de mes.'
  }];
  return <section className="bg-[#111111] py-14 px-4 relative overflow-hidden" data-id="element-12">
      {/* Gold Header Bar */}
      <div className="absolute top-0 left-0 right-0 bg-[#D4A017] py-4 text-center" data-id="element-13">
        <h2 className="text-black font-black text-2xl md:text-3xl uppercase tracking-wider flex items-center justify-center gap-3" data-id="element-14">
          <Gift className="w-8 h-8" data-id="element-15" />
          Y además recibís estos 6 BONOS GRATIS
          <Gift className="w-8 h-8" data-id="element-16" />
        </h2>
      </div>

      <div className="container mx-auto max-w-6xl mt-16" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-18">
          <p className="text-gray-300 text-xl font-medium" data-id="element-19">
            Valorados en{' '}
            <span className="line-through text-red-500" data-id="element-20">$156.000 ARS</span> ·
            Hoy incluidos sin costo adicional
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-21">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#0A0A0A] border border-[#D4A017]/30 rounded-xl p-6 hover:border-[#D4A017] transition-colors flex flex-col" data-id="element-22">
              <div className="bg-[#D4A017]/10 text-[#D4A017] text-xs font-bold px-3 py-1 rounded-full w-fit mb-4 uppercase tracking-wider" data-id="element-23">
                Bono #{index + 1}
              </div>
              <h3 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-24">
                {bono.title}
              </h3>
              <div className="flex items-center gap-2 mb-4" data-id="element-25">
                <span className="text-gray-500 line-through text-sm" data-id="element-26">
                  Valor {bono.value}
                </span>
                <span className="text-green-500 font-bold text-sm uppercase bg-green-500/10 px-2 py-0.5 rounded" data-id="element-27">
                  → GRATIS
                </span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed flex-grow" data-id="element-28">
                {bono.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="max-w-2xl mx-auto bg-[#D4A017] rounded-2xl p-8 shadow-[0_0_40px_rgba(212,160,23,0.2)] text-black" data-id="element-29">
          <h3 className="text-2xl font-black text-center mb-6 uppercase border-b border-black/20 pb-4" data-id="element-30">
            Resumen de Valor
          </h3>

          <div className="space-y-4 mb-6 font-medium text-lg" data-id="element-31">
            <div className="flex justify-between items-center" data-id="element-32">
              <div className="flex items-center gap-2" data-id="element-33">
                <Check className="w-5 h-5" data-id="element-34" />
                <span data-id="element-35">6 Tomos Técnicos</span>
              </div>
              <span className="font-bold" data-id="element-36">$120.000</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-37">
              <div className="flex items-center gap-2" data-id="element-38">
                <Check className="w-5 h-5" data-id="element-39" />
                <span data-id="element-40">6 Bonos Exclusivos</span>
              </div>
              <span className="font-bold" data-id="element-41">$156.000</span>
            </div>
            <div className="border-t border-black/20 pt-4 flex justify-between items-center text-gray-800" data-id="element-42">
              <span data-id="element-43">VALOR TOTAL:</span>
              <span className="line-through font-bold" data-id="element-44">$276.000 ARS</span>
            </div>
          </div>

          <div className="bg-black text-white rounded-xl p-6 text-center transform scale-105 shadow-xl" data-id="element-45">
            <p className="text-[#D4A017] font-bold uppercase tracking-widest text-sm mb-1" data-id="element-46">
              Precio Hoy
            </p>
            <p className="text-5xl font-black" data-id="element-47">
              $19.990{' '}
              <span className="text-xl font-medium text-gray-400" data-id="element-48">ARS</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}